import type { SVGProps } from "react";

const UserPlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6667 17.5V15.8333C11.6667 14.9493 11.3155 14.1014 10.6904 13.4763C10.0652 12.8512 9.21739 12.5 8.33333 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80964 13.4763C1.18452 14.1014 0.833336 14.9493 0.833336 15.8333V17.5"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 9.16667C8.09095 9.16667 9.58333 7.67428 9.58333 5.83333C9.58333 3.99238 8.09095 2.5 6.25 2.5C4.40905 2.5 2.91667 3.99238 2.91667 5.83333C2.91667 7.67428 4.40905 9.16667 6.25 9.16667Z"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 6.66667V11.6667" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 9.16667H12.5" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default UserPlusIcon;
